<script setup>
import { computed, ref } from 'vue';
import { useQuery } from 'villus';
import { useStore } from '@/store/Store.js';
import Caret from '@/icons/caret.svg';

const allCrumbs = ref([]);

const store = useStore();

const props = defineProps({
    entry: {
        type: String,
        default: '',
    },
    crumbs: {
        type: Array,
        default: () => [],
    },
});

const variables = computed(() => ({
    lang: store.lang.value,
    slug: props.entry,
}));

const { data } = await useQuery({
    variables,
    query: `
        query FetchBreadcrumbs($lang: [String], $slug: [String]) {
            entry (site: $lang, type: $slug) {
                id
                title
                uri
                ... on abouts_about_Entry {
                    breadcrumbs {
                        url
                        text
                    }
                }
                ... on products_Entry {
                    breadcrumbs {
                        url
                        text
                    }
                }
                ... on location_Entry {
                    breadcrumbs {
                        url
                        text
                    }
                }
                ... on contact_Entry {
                    breadcrumbs {
                        url
                        text
                    }
                }
                ... on discounts_Entry {
                    breadcrumbs {
                        url
                        text
                    }
                }
                ... on blogs_Entry {
                    breadcrumbs {
                        url
                        text
                    }
                }
                ... on faqs_Entry {
                    breadcrumbs {
                        url
                        text
                    }
                }
                ... on bio_principal_Entry {
                    breadcrumbs {
                        url
                        text
                    }
                }
                ... on recettes_Entry {
                    breadcrumbs {
                        url
                        text
                    }
                }
            }
        }
    `,
});

if (data.value && data.value.entry && data.value.entry.breadcrumbs && data.value.entry.breadcrumbs.length > 0) {
    allCrumbs.value = data.value.entry.breadcrumbs;
}
if (props.crumbs && props.crumbs.length > 0) {
    allCrumbs.value = allCrumbs.value.concat(props.crumbs);
}
</script>

<template>
    <div
        v-if="allCrumbs.length > 0"
        class="Breadcrumb groupnot flex min-h-6 flex-wrap items-center gap-2 leading-none"
    >
        <div
            v-for="(crumb, crumbIndex) in allCrumbs"
            :key="crumb.url"
            class="Breadcrumb__item flex items-center gap-2 whitespace-nowrap"
        >
            <component
                :is="crumb.url ? 'router-link' : 'span'"
                class="whitespace-nowrap border-b-2 border-transparent transition groupnot-hover:opacity-50"
                :class="{
                    'hover:border-current': crumb.url,
                }"
                :to="crumb.url ? setUri({ lang: lang, uri: crumb.url }) : null"
            >
                {{ crumb.text }}
            </component>

            <span class="inline-flex items-center border-b-2 border-transparent"
                ><Caret
                    v-if="crumbIndex + 1 !== allCrumbs.length"
                    class="inline-block h-1.5 w-auto fill-current"
            /></span>
        </div>
    </div>
    <div
        v-else
        class="Breadcrumb__spacing min-h-6 leading-none"
    />
</template>
